import store from '@/app/store/store';
import type { AtomConfig } from './type';

export const keyRegisterEvent = '__customEvents';
export const keyAddEvent = '__addEvent';
export const keyRegisterAction = '__customActions';
export const keyAddAction = '__addAction';

/**
 * initRegisterAction
 */
export const initRegisterAction = (): void => {
  //
  store.onChange(keyAddEvent, function (registerEvent) {
    if (!registerEvent.key) {
      return;
    }

    const listCustomEvent = store.getValue(keyRegisterEvent) || [];
    //check isset key in list
    let existed = false;
    for (let i = 0; i < listCustomEvent.length; i++) {
      if (listCustomEvent[i].key == registerEvent.key) {
        existed = true;
      }
    }
    if (!existed) {
      listCustomEvent.push(registerEvent);
    }

    store.setValue(keyRegisterEvent, listCustomEvent);
  });

  //actions
  store.onChange(keyAddAction, function (registerAction) {
    if (!registerAction.key) {
      return;
    }
    const listCustomAction = store.getValue(keyRegisterAction) || [];
    //check isset key in list
    let existed = false;
    for (let i = 0; i < listCustomAction.length; i++) {
      if (listCustomAction[i].key == registerAction.key) {
        existed = true;
      }
    }
    if (!existed) {
      listCustomAction.push(registerAction);
    }
    // console.log(listCustomAction);
    store.setValue(keyRegisterAction, listCustomAction);
  });
};
//events

/* 
Atom Config
*/
export const atomLevel1: Map<string, AtomConfig> = new Map();
atomLevel1.set('Row', {
  target: '',
});
atomLevel1.set('Parallax', {
  target: '',
});
atomLevel1.set('Hero Banner', {
  target: '',
});
atomLevel1.set('Tabs', {
  target: '',
});
atomLevel1.set('Carousel', {
  target: '',
});
atomLevel1.set('Pricing', {
  target: '',
});
atomLevel1.set('Accordion', {
  target: '',
});
atomLevel1.set('Product', {
  target: '',
});
atomLevel1.set('Product List', {
  target: '',
});
atomLevel1.set('Related Products', {
  target: '',
});
atomLevel1.set('Icon List Hoz', {
  target: '',
});
atomLevel1.set('Icon List', {
  target: '',
});
atomLevel1.set('Google Maps', {
  target: '',
});
atomLevel1.set('Instagram', {
  target: '',
});
atomLevel1.set('Popup', {
  target: '',
});
atomLevel1.set('Video Bg', {
  target: '',
});
atomLevel1.set('Product', {
  target: '',
});
atomLevel1.set('Product List', {
  target: '',
});
atomLevel1.set('Related Products', {
  target: '',
});
atomLevel1.set('(P) Meta', {
  target: '.module',
});
atomLevel1.set('Mailchimp', {
  target: '',
});
atomLevel1.set('Contact Form', {
  target: '.module',
});
atomLevel1.set('Article List', {
  target: '.module',
});

export const atomLevel2: Map<string, AtomConfig> = new Map();
atomLevel2.set('Heading', {
  target: '.elm',
});
atomLevel2.set('Text Block', {
  target: '.elm',
});
atomLevel2.set('Image', {
  target: '.gf_image',
});
atomLevel2.set('Icon', {
  target: '.gf_icon-wrap',
});
atomLevel2.set('Button', {
  target: '.gf_button',
});
atomLevel2.set('Separator', {
  target: '.elm',
});
atomLevel2.set('Liquid', {
  target: '',
});
atomLevel2.set('Video Popup', {
  target: '.video-popup',
});
atomLevel2.set('Youtube', {
  target: '.module',
});
atomLevel2.set('Vimeo', {
  target: '.module',
});
atomLevel2.set('(P) Title', {
  target: '.module',
});
atomLevel2.set('(P) Description', {
  target: '.gf_product-desc',
});
atomLevel2.set('(P) Price', {
  target: '.module',
});
atomLevel2.set('(P) Quantity', {
  target: '.module',
});
atomLevel2.set('(P) Variants', {
  target: '.module',
});
atomLevel2.set('(P) Swatches', {
  target: '.module',
});
atomLevel2.set('(P) Cart Button', {
  target: '.gf_add-to-cart',
});
atomLevel2.set('(P) View More', {
  target: '.gf_view-more',
});
atomLevel2.set('(P) Stock Counter', {
  target: '.module',
});
atomLevel2.set('Count Down', {
  target: '.count-down-wrap',
});
atomLevel2.set('Countdown Timer', {
  target: '.count-down-wrap',
});
atomLevel2.set('Counter', {
  target: '.module',
});
atomLevel2.set('Social Share', {
  target: '.module',
});
atomLevel2.set('Email Field', {
  target: '.elm',
});
atomLevel2.set('Text Field', {
  target: '.elm',
});
atomLevel2.set('Text Area', {
  target: '.elm',
});
atomLevel2.set('Dropdown', {
  target: '.elm',
});
atomLevel2.set('Checkbox', {
  target: '.elm',
});
atomLevel2.set('Submit Button', {
  target: '.elm',
});
atomLevel2.set('(A) Title', {
  target: '.module',
});
atomLevel2.set('(A) Content', {
  target: '.module',
});
atomLevel2.set('(A) Image', {
  target: '.module',
});
atomLevel2.set('(A) Date', {
  target: '.module',
});
atomLevel2.set('Collection Banner', {
  target: '.module',
});
atomLevel2.set('Collection Title', {
  target: '.module',
});
atomLevel2.set('Collection Desc', {
  target: '.module',
});
atomLevel2.set('Collection Toolbar', {
  target: '.module',
});
atomLevel2.set('Paginator', {
  target: '.module',
});
atomLevel2.set('(A) Excerpt', {
  target: '.module',
});
atomLevel2.set('Ali Reviews', {
  target: '.module',
});
atomLevel2.set('Growave', {
  target: '.module',
});
atomLevel2.set('Judge Reviews', {
  target: '.module',
});
atomLevel2.set('Product Reviews', {
  target: '.module',
});
atomLevel2.set('Trustoo', {
  target: '.module',
});
atomLevel2.set('Loox Carousel/HomePage Widget', {
  target: '.module',
});
atomLevel2.set('Klaviyo Signup Form', {
  target: '.module',
});
atomLevel2.set('Klaviyo: Email Marketing & SMS', {
  target: '.module',
});
atomLevel2.set('Judge Reviews Carousel', {
  target: '.module',
});
atomLevel2.set('Infinite Options', {
  target: '.module',
});
atomLevel2.set('Recharge Subscription', {
  target: '.module',
});
atomLevel2.set('Bold Subscriptions', {
  target: '.module',
});
atomLevel2.set('Bold Product Options', {
  target: '.module',
});
atomLevel2.set('Frequently Bought Together', {
  target: '.module',
});
atomLevel2.set('Cross Sell', {
  target: '.module',
});
atomLevel2.set('Product Filter Search', {
  target: '.module',
});
atomLevel2.set('Ryviu: Product Review App', {
  target: '.module',
});
atomLevel2.set('Stamped', {
  target: '.module',
});
atomLevel2.set('Stamped Display', {
  target: '.module',
});
atomLevel2.set('Stamped.io Product Reviews', {
  target: '.module',
});
atomLevel2.set('Rivyo Reviews', {
  target: '.module',
});
atomLevel2.set('Rivyo Reviews Testimonial', {
  target: '.module',
});
atomLevel2.set('Rivyo Product Reviews', {
  target: '.module',
});
atomLevel2.set('Ryviu Featured', {
  target: '.module',
});
atomLevel2.set('Ryviu Product Reviews', {
  target: '.module',
});
atomLevel2.set('Opinew Featured', {
  target: '.module',
});
atomLevel2.set('Opinew Reviews', {
  target: '.module',
});
atomLevel2.set('Opinew Product Reviews', {
  target: '.module',
});
atomLevel2.set('Yotpo - Product & Collection Page', {
  target: '.module',
});
atomLevel2.set('Yotpo - Custom Pages', {
  target: '.module',
});
atomLevel2.set('(P) Dynamic Checkout Button', {
  target: '.module',
});
atomLevel2.set('Image Before After', {
  target: '.module',
});
atomLevel2.set('Wiser - Personalized Recommendations Featured', {
  target: '.module',
});
atomLevel2.set('Wiser - Personalized Recommendations', {
  target: '.module',
});
atomLevel2.set('Instafeed', {
  target: '.module',
});
atomLevel2.set('Product Personalizer', {
  target: '.module',
});
atomLevel2.set('Facebook Widget', {
  target: '.module',
});
atomLevel2.set('Appstle Subscriptions', {
  target: '.module',
});

export const allAtomsIntegration: Map<string, AtomConfig> = new Map([...atomLevel1, ...atomLevel2]);
